import React from 'react';
export function AuroraBackground() {
  return <div className="fixed inset-0 -z-10 overflow-hidden" data-id="element-3">
      {/* Base cream gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FBF8F3] via-[#F5F1E8] to-[#F9F5EF]" data-id="element-4" />

      {/* Aurora layers - subtle cream, taupe, and gold tones */}
      <div className="absolute inset-0" data-id="element-5">
        {/* Soft taupe wave 1 */}
        <div className="absolute w-[800px] h-[800px] rounded-full blur-3xl opacity-20" style={{
        background: 'radial-gradient(circle, rgba(212, 165, 116, 0.4) 0%, rgba(200, 180, 150, 0.2) 50%, transparent 70%)',
        top: '-20%',
        left: '10%',
        animation: 'float1 20s ease-in-out infinite'
      }} data-id="element-6" />

        {/* Gentle gold wave 2 */}
        <div className="absolute w-[700px] h-[700px] rounded-full blur-3xl opacity-15" style={{
        background: 'radial-gradient(circle, rgba(232, 184, 109, 0.3) 0%, rgba(220, 200, 160, 0.15) 50%, transparent 70%)',
        top: '10%',
        right: '5%',
        animation: 'float2 25s ease-in-out infinite'
      }} data-id="element-7" />

        {/* Cream wave 3 */}
        <div className="absolute w-[600px] h-[600px] rounded-full blur-3xl opacity-18" style={{
        background: 'radial-gradient(circle, rgba(245, 241, 232, 0.5) 0%, rgba(235, 225, 210, 0.25) 50%, transparent 70%)',
        top: '30%',
        left: '20%',
        animation: 'float3 22s ease-in-out infinite'
      }} data-id="element-8" />

        {/* Soft taupe wave 4 */}
        <div className="absolute w-[750px] h-[750px] rounded-full blur-3xl opacity-16" style={{
        background: 'radial-gradient(circle, rgba(200, 180, 150, 0.35) 0%, rgba(212, 165, 116, 0.2) 50%, transparent 70%)',
        bottom: '10%',
        left: '40%',
        animation: 'float4 18s ease-in-out infinite'
      }} data-id="element-9" />

        {/* Delicate gold wave 5 */}
        <div className="absolute w-[650px] h-[650px] rounded-full blur-3xl opacity-14" style={{
        background: 'radial-gradient(circle, rgba(232, 184, 109, 0.25) 0%, rgba(245, 230, 211, 0.15) 50%, transparent 70%)',
        bottom: '20%',
        right: '15%',
        animation: 'float5 24s ease-in-out infinite'
      }} data-id="element-10" />
      </div>
    </div>;
}